<template>
<div class="full-wrapper">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <el-row>
        <w-performance-analysis-chart-view :active="active" :perf-chart-type-data="perfChartType"/>
      </el-row>
      <hr class="mr-b20"/>
      <el-row>
        <w-performance-server-analysis-table :active="active" :operation-flag="false"/>
      </el-row>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import ScrollbarMixin from '@/mixins/scrollbar';
import WPerformanceServerAnalysisTable from '@/views/performance/node/analysis/server/PerformanceServerAnalysisTable';
import WPerformanceAnalysisChartView from '@/views/performance/node/analysis/components/PerformanceAnalysisChartView';
// import WPerformanceServerAnalysisChart from './PerformanceServerAnalysisChart';
import perfChartType from './perf-chart-type';

export default {
  name: 'WPerformanceServerAnaylsis',
  mixins: [ScrollbarMixin],
  components: {
    WPerformanceServerAnalysisTable,
    // WPerformanceServerAnalysisChart,
    WPerformanceAnalysisChartView,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      perfChartType,
    };
  },
  mounted() {
    this.setScrollData();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/analysis/server/index.vue